import React, { ReactNode } from 'react';
type ArticleSectionProps = {
  id: string;
  title: string;
  children: ReactNode;
};
export function ArticleSection({
  id,
  title,
  children
}: ArticleSectionProps) {
  return <section id={id} aria-labelledby={`${id}-title`} className="scroll-mt-24 border-t border-line pt-12 first:border-0 first:pt-0" data-id="element-13" data-mp="3iu9euefvk4z3">
      <h2 id={`${id}-title`} className="font-display text-3xl font-semibold leading-tight tracking-tight text-ink md:text-[2.25rem]" data-id="element-14" data-mp="3dwrehcfxay2p">
        {title}
      </h2>
      <div className="article-body mt-5" data-id="element-15" data-mp="3nrrq4bhd6wa9">{children}</div>
    </section>;
}